import { createContext } from 'react'
import { CopilotState } from './types'

export interface CopilotApi {
  state: CopilotState
  open(): void
  close(): void
  setActive(clientId: string): void
  startRun(files: File[], instruction: string): Promise<void>
  answer(clientId: string, text: string, files?: File[]): Promise<void>
  confirm(clientId: string, approved: boolean, reason?: string): Promise<void>
  interrupt(clientId: string): Promise<void>
}

export const CopilotContext = createContext<CopilotApi | null>(null)
